import { Tag } from "@brg/api";
import { FC, useMemo } from "react";
import { SearchResults } from "../SearchResults";
import { TagsAvailableTitle } from "../styles";

interface TagsSearchResultsProps {
  displayedTags: Tag[];
  filteredTags: (arr: Tag<"Local">[]) => Tag<"Local">[];
  getGrouping: () => number;
  onTagSelect: (tag: Tag) => void;
  shouldVisibleEducationCategory: boolean | undefined;
  isMobileMenu?: boolean;
  viewAllTags?: boolean;
  load: boolean | undefined;
  isEdit?: boolean;
  onMoreClick: () => void;
  showAllTagsInGroup: boolean;
  isTagEditor?: number;
  t: (key: string) => string;
  activeTab?: 'tags' | 'selected';
}

export const TagsSearchResults: FC<TagsSearchResultsProps> = ({
  displayedTags,
  filteredTags,
  getGrouping,
  onTagSelect,
  shouldVisibleEducationCategory,
  isMobileMenu,
  viewAllTags,
  load,
  isEdit,
  onMoreClick,
  showAllTagsInGroup,
  isTagEditor,
  t,
  activeTab,
}) => {
  const visible = useMemo(() => {
    const baseVisible = load !== true;
    return activeTab ? baseVisible && activeTab === 'tags' : baseVisible;
  }, [load, activeTab]);

  return useMemo(
    () => (
      <SearchResults
        tags={filteredTags(displayedTags)}
        grouping={getGrouping()}
        onTagSelect={onTagSelect}
        shouldVisibleEducationCategory={shouldVisibleEducationCategory}
        isMobileMenu={isMobileMenu}
        viewAllTags={viewAllTags}
        visible={visible}
        isEdit={isEdit}
        onMoreClick={onMoreClick}
        showAllTagsInGroup={showAllTagsInGroup}
      >
        {isTagEditor && (
          <TagsAvailableTitle
            style={{ display: 'inline-flex', placeItems: 'center', whiteSpace: 'nowrap' }}
          >
            {t('available_tags_in_project')}
          </TagsAvailableTitle>
        )}
      </SearchResults>
    ),
    [
      t,
      isTagEditor,
      isMobileMenu,
      visible,
      shouldVisibleEducationCategory,
      viewAllTags,
      onTagSelect,
      getGrouping,
      displayedTags,
      showAllTagsInGroup,
      filteredTags,
      isEdit,
      onMoreClick,
    ]
  );
};
import { Tag } from "@brg/api";
import { FC, useMemo } from "react";
import { SearchResults } from "../SearchResults";
import { TagsAvailableTitle } from "../styles";

interface TagsSearchResultsProps {
  displayedTags: Tag[];
  filteredTags: (arr: Tag<"Local">[]) => Tag<"Local">[];
  getGrouping: () => number;
  onTagSelect: (tag: Tag) => void;
  shouldVisibleEducationCategory: boolean | undefined;
  isMobileMenu?: boolean;
  viewAllTags?: boolean;
  load: boolean | undefined;
  isEdit?: boolean;
  onMoreClick: () => void;
  showAllTagsInGroup: boolean;
  isTagEditor?: number;
  t: (key: string) => string;
  activeTab?: 'tags' | 'selected';
}

export const TagsSearchResults: FC<TagsSearchResultsProps> = ({
  displayedTags,
  filteredTags,
  getGrouping,
  onTagSelect,
  shouldVisibleEducationCategory,
  isMobileMenu,
  viewAllTags,
  load,
  isEdit,
  onMoreClick,
  showAllTagsInGroup,
  isTagEditor,
  t,
  activeTab,
}) => {
  const visible = useMemo(() => {
    const baseVisible = load !== true;
    return activeTab ? baseVisible && activeTab === 'tags' : baseVisible;
  }, [load, activeTab]);

  return useMemo(
    () => (
      <SearchResults
        tags={filteredTags(displayedTags)}
        grouping={getGrouping()}
        onTagSelect={onTagSelect}
        shouldVisibleEducationCategory={shouldVisibleEducationCategory}
        isMobileMenu={isMobileMenu}
        viewAllTags={viewAllTags}
        visible={visible}
        isEdit={isEdit}
        onMoreClick={onMoreClick}
        showAllTagsInGroup={showAllTagsInGroup}
      >
        {isTagEditor && (
          <TagsAvailableTitle
            style={{ display: 'inline-flex', placeItems: 'center', whiteSpace: 'nowrap' }}
          >
            {t('available_tags_in_project')}
          </TagsAvailableTitle>
        )}
      </SearchResults>
    ),
    [
      t,
      isTagEditor,
      isMobileMenu,
      visible,
      shouldVisibleEducationCategory,
      viewAllTags,
      onTagSelect,
      getGrouping,
      displayedTags,
      showAllTagsInGroup,
      filteredTags,
      isEdit,
      onMoreClick,
    ]
  );
};
